if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    static get observedAttributes() {
      return ['data-cart-total-amount', 'data-free-shipping'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        this.init();
      }
    }

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const thresholdAmount = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const progress = thresholdAmount > 0 ? Math.min(100, (cartTotal / thresholdAmount) * 100) : 0;

	  const svgIconCar = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M19.5264 9.93546L17.3249 7.22534C17.0544 6.8924 16.6532 6.70135 16.2243 6.70135H13.3014V4.15436C13.3014 3.3725 12.6653 2.73636 11.8834 2.73636H9.13811V2.56836C9.13811 2.22321 8.85826 1.94336 8.51311 1.94336H4.94453C4.59938 1.94336 4.31953 2.22321 4.31953 2.56836V2.73636H1.57425C0.792389 2.73636 0.15625 3.3725 0.15625 4.15436V14.2653C0.15625 15.0471 0.792389 15.6833 1.57425 15.6833H3.33809C3.41817 17.0054 4.51606 18.0573 5.85793 18.0573C7.19979 18.0573 8.29768 17.0054 8.37776 15.6833H12.6764H12.8512C12.9313 17.0054 14.0292 18.0573 15.371 18.0573C16.7129 18.0573 17.8108 17.0054 17.8909 15.6833H18.4258C19.2076 15.6833 19.8438 15.0471 19.8438 14.2653V10.8295C19.8438 10.5048 19.731 10.1874 19.5264 9.93546ZM5.56953 3.19336H7.88811V5.8223L7.10083 5.23911C6.99036 5.15717 6.85959 5.11627 6.72882 5.11627C6.59805 5.11627 6.46729 5.15717 6.35681 5.23911L5.56953 5.8223V3.19336ZM1.40625 14.2653V4.15436C1.40625 4.06174 1.48163 3.98636 1.57425 3.98636H4.31953V7.06299C4.31953 7.29904 4.45251 7.51495 4.66339 7.62115C4.87434 7.72751 5.12695 7.70569 5.31654 7.56516L6.72882 6.51901L8.1411 7.56516C8.25081 7.64648 8.38158 7.68799 8.51318 7.68799C8.60909 7.68799 8.70537 7.66602 8.79425 7.62115C9.00513 7.51495 9.13811 7.29904 9.13811 7.06299V3.98636H11.8834C11.976 3.98636 12.0514 4.06174 12.0514 4.15436V7.32635V14.4333H8.13188C7.72255 13.5879 6.8585 13.002 5.85793 13.002C4.85735 13.002 3.9933 13.5879 3.58397 14.4333H1.57425C1.48163 14.4333 1.40625 14.3579 1.40625 14.2653ZM5.85793 16.8073C5.15343 16.8073 4.58031 16.2341 4.58031 15.5296C4.58031 14.8251 5.15343 14.252 5.85793 14.252C6.56242 14.252 7.13554 14.8251 7.13554 15.5296C7.13554 16.2341 6.56242 16.8073 5.85793 16.8073ZM15.371 16.8073C14.6665 16.8073 14.0934 16.2341 14.0934 15.5296C14.0934 14.8251 14.6665 14.252 15.371 14.252C16.0755 14.252 16.6486 14.8251 16.6486 15.5296C16.6486 16.2341 16.0755 16.8073 15.371 16.8073ZM18.5938 14.2653C18.5938 14.3579 18.5184 14.4333 18.4258 14.4333H17.645C17.2356 13.5879 16.3716 13.002 15.371 13.002C14.5153 13.002 13.7589 13.4305 13.3014 14.083V7.95135H16.2243C16.2751 7.95135 16.3226 7.97409 16.3548 8.01361L18.5562 10.7237C18.5804 10.7535 18.5938 10.791 18.5938 10.8295V14.2653Z" fill="#101B3B"/></svg> `
      const freeShippingRemaining = cartTotal - thresholdAmount;
      let shippingMessage = '';
      let shippingSuccess = false

      if ( cartTotal === 0 ) {
        shippingMessage = svgIconCar + window.KROWN.settings.locales.shipping_notice_empty;
      } else if ( freeShippingRemaining < 0 ) {
        shippingMessage = svgIconCar + window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
      } else {
        shippingMessage = svgIconCar + window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
        
        if (!ShippingNotice.freeShippingTriggered) {
          ShippingNotice.freeShippingTriggered = true;
          this.classList.add('free-shipping');
          setTimeout(() => {
            this.classList.remove('free-shipping');
          }, 4000);
        }
      }

      if (!shippingSuccess) {
        ShippingNotice.freeShippingTriggered = false;
      }
     

      if ( !this.shadowRoot.querySelector('.shipping-notice-progress') ) {
        const lastProgress = ShippingNotice.lastProgress || 0;
        this.shadowRoot.innerHTML = `
          <style>
            :host {
              display: block;
              margin-bottom: 20px;
            }
            .shipping-notice-progress {
              width: 100%;
              height: 8px;
              background-color: #D9DFF2;
              border-radius: 100px;
              margin-top: 12px;
              position: relative;
              overflow: hidden;
            }
            .shipping-notice-progress__fill {
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              background-color: #F33182;
              border-radius: 100px;
              width: ${lastProgress}%;
              transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            } 
          </style>
          <slot></slot>
          <div class="shipping-notice-progress">
            <div class="shipping-notice-progress__fill"></div>
          </div>
        `;
      }

      const fill = this.shadowRoot.querySelector('.shipping-notice-progress__fill');
      if (fill) {
        // We use two frames to ensure the initial width (from lastProgress) is painted 
        // before we trigger the change to the new progress.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.width = `${progress}%`;
            ShippingNotice.lastProgress = progress;
          });
        });
      }

      const content = this.hasAttribute('data-show-alert') ? `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>` : shippingMessage;

      if ( this.innerHTML !== content ) {
        this.innerHTML = content;
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}